import * as types from "./act_actionTypes";
import * as HeaderAuthentication from '../../HeaderAuthentication'
import { baseURL } from "../../BaseURL";
import Swal from "sweetalert2";
import { toast } from 'react-toastify';
import { getToataldataCount } from "../action";
import { getToatalPages } from "../subscriptionServices/sb_action";

let headerAuth = HeaderAuthentication.getRequestOptions;
// #region storing data to reducer
const getRecentActivities = (recent_activity_data) => ({
    type: types.get_recent_activities,
    payload: recent_activity_data
})
// #endregion

// #region api service call fucntions
export const loadRecentActivities = (params) => {
    return function (dispatch, getState) {
        return fetch(`${baseURL}/dashboard/get_recent_activities?page=${params.page}&page_size=${params.page_size}&start_date=${params.start_date}&end_date=${params.end_date}&activity_type=${params.activity_type}&search_text=${params.search_text}`, headerAuth)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 200) {
                    // dispatch(getRecentActivities(resp.activities))
                    if (params.page > 1) {
                        const state = getState();
                        const currentdata = state.activitydata?.recent_activity_data || [];

                        const updatedSubscriptions = [...currentdata, ...resp.activities];
                        dispatch(getRecentActivities(updatedSubscriptions));
                    } else {
                        dispatch(getRecentActivities(resp.activities));
                    }
                    dispatch(getToataldataCount(resp.total_records))
                    dispatch(getToatalPages(resp.total_pages))
                    return resp
                }
            })
            .catch((err) => {
                // toast.error(`${err}`);
                console.log(err);
            });
    }
}
// #endregion